"use client";

import { useLocale, useTranslations } from "next-intl";
import { usePathname, useRouter } from "@/i18n/navigation";

export default function LanguageToggle({ className }: { className?: string }) {
  const locale = useLocale();
  const t = useTranslations("common");
  const pathname = usePathname();
  const router = useRouter();
  const other = locale === "ar" ? "en" : "ar";
  const label = other === "ar" ? t("switchToArabic") : t("switchToEnglish");

  function switchTo() {
    // Persist choice for a year; the proxy reads NEXT_LOCALE to stop
    // auto-applying the Gulf geo default once the user has picked.
    document.cookie = `NEXT_LOCALE=${other}; path=/; max-age=${60 * 60 * 24 * 365}`;
    router.replace(pathname, { locale: other });
  }

  return (
    <button
      type="button"
      onClick={switchTo}
      aria-label={label}
      className={className ?? "text-sm font-semibold text-ss-text hover:text-ss-blue transition-colors"}
    >
      {label}
    </button>
  );
}
